import { memo } from 'react';
import Image from 'next/image';
import emailIcon from '../../assets/icons/Email_Icon.png';
import phoneIcon from '../../assets/icons/Phone_Icon.png';
import styles from './CTACards.module.scss';

const DEFAULT_ICON_SIZE = 80;

export const CTACards = memo(({ onOpenEmailModal, phoneNumber }) => {
  return (
    <section className={styles.cardsContainer}>
      <button type="button" className={styles.ctaCard} onClick={onOpenEmailModal}>
        <Image alt="Send Email" src={emailIcon} width={DEFAULT_ICON_SIZE} height={DEFAULT_ICON_SIZE} />
        <p>Email</p>
      </button>
      {phoneNumber && (
        <a className={styles.ctaCard} href={`tel:${phoneNumber?.anchor}`}>
          <Image alt="Make a Phone Call" src={phoneIcon} width={DEFAULT_ICON_SIZE} height={DEFAULT_ICON_SIZE} />
          <p>Call</p>
        </a>
      )}
    </section>
  );
});
